import {Injectable} from "@angular/core";
import {NgbDatepickerI18nDefault, NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {TranslocoService} from "@jsverse/transloco";

enum Month {
  Jaanuar, Veebruar, Märts, Aprill, Mai, Juuni, Juuli, August, September, Oktoober, November, Detsember
}

enum MonthShort{
  Jaan, Veebr, Märts, Apr, Mai, Juuni, Juuli, Aug, Sept, Okt, Nov, Dets
}
enum Weekdays {
  E, T, K, N, R, L, P
}

@Injectable({providedIn: 'root'})
export class TranslocoDatepickerI18n extends NgbDatepickerI18nDefault {
  constructor(private translocoService: TranslocoService) {
    super();
  }

  getMonthShortName(month: number, year?: number): string {
    let s = MonthShort[month - 1];
    return this.translocoService.translate('common.date-picker.month.' + s, {year: year, month: month})
  }

  getMonthFullName(month: number): string {
    let s = Month[month - 1];
    return this.translocoService.translate('common.date-picker.month.' + s, {month: month})
  }

  getMonthLabel(date: NgbDateStruct): string {
    let s = Month[date.month - 1];
    return this.translocoService.translate('common.date-picker.month.' + s, {year: date.year, month: date.month, day: date.day})
  }

  getWeekdayLabel(weekday: number) {
    let s = Weekdays[weekday - 1];
    return this.translocoService.translate('common.date-picker.week-day.' + s)
  }
}
